export default "__VITE_ASSET__DYvr3uvD__"